import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from '../contexts/AuthContext'

const AdminRoute = () => {
    const {user} = useAuth()
    // cek apakah rolenya admin atau super_admin atau developer
    if (user?.role === 'admin' || user?.role === 'super_admin' || user?.role === 'developer') {
        return <Outlet />
    }
    return <Navigate to="/mading" replace />
}

export default AdminRoute;